import { Type } from "nanium/objects";

export const availabilityStatus = {
  available: 'aktuell verfügbar',
  waitlist: 'Warteliste',
  unavailable: 'aktuell nicht verfügbar'
};

export class ClubFeatures {
  // Mehrsprachigkeit
  @Type(Boolean) langGerman?: boolean;
  @Type(Boolean) langEnglish?: boolean;
  @Type(Boolean) langArabic?: boolean;
  @Type(Boolean) langTurkish?: boolean;
  @Type(Boolean) langRussian?: boolean;
  @Type(Boolean) langUkrainian?: boolean;
  @Type(Boolean) langPolish?: boolean;
  @Type(Boolean) langFrench?: boolean;
  @Type(Boolean) langSpanish?: boolean;

  // Barrierefreiheit
  @Type(Boolean) accWheelchairAccess?: boolean;
  @Type(Boolean) accWheelchairToilet?: boolean;
  @Type(Boolean) accElevator?: boolean;
  @Type(Boolean) accSignLanguage?: boolean;

  // Ausstattungsmerkmale
  @Type(Boolean) equipWifi?: boolean;
  @Type(Boolean) equipComputers?: boolean;
  @Type(Boolean) equipGaming?: boolean;
  @Type(Boolean) equipMusicStudio?: boolean;
  @Type(Boolean) equipWorkshop?: boolean;
  @Type(Boolean) equipKitchen?: boolean;
  @Type(Boolean) equipSportsRoom?: boolean;
  @Type(Boolean) equipSoccerField?: boolean;
  @Type(Boolean) equipVolleyballField?: boolean;
  @Type(Boolean) equipTableTennis?: boolean;
  @Type(Boolean) equipMakerSpace?: boolean;

  // Verfügbarkeit (Werte: 'available' | 'waitlist' | 'unavailable')
  @Type(String) internshipAvailability?: string;
  @Type(String) volunteerServiceAvailability?: string;
  @Type(String) apprenticeshipAvailability?: string;

  // Erreichbarkeit
  @Type(Boolean) transportPublic?: boolean;
  @Type(Boolean) transportParking?: boolean;

  // Beratung & Unterstützung
  @Type(Boolean) counsSocialPedagogical?: boolean;
  @Type(Boolean) counsSchoolJobHelp?: boolean;
  @Type(Boolean) counsCrisis?: boolean;
  @Type(Boolean) counsJobApplication?: boolean;
}
